/**
 * @generated by Icons/generate-icons.ts — do not edit by hand.
 * Source: svg/SilverBadge.svg. Edit that .svg (or svg/icons.config.json) and run
 * `pnpm --filter @gigpro/ui generate:icons`.
 */
import type { IconComponent } from "./types";

export const SilverBadge: IconComponent = ({ ref, color = "currentColor", ...props }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 71 28" ref={ref} {...props}>
    <rect width="71" height="28" fill="url(#SilverBadge-silver-badge-bg)" rx="14" />
    <path
      fill="#262626"
      d="M23.1 7.38a.44.44 0 0 1 .2.56l-2.24 5.43a5.7 5.7 0 0 0-3.87-2.46l1.36-3.3a.4.4 0 0 1 .4-.28h3.95q.1 0 .2.05m-8.99.22 1.36 3.3a5.7 5.7 0 0 0-3.87 2.47L9.37 7.94a.44.44 0 0 1 .4-.6h3.94a.4.4 0 0 1 .4.26m2.22 4.1a4.81 4.81 0 1 0 0 9.63 4.81 4.81 0 0 0 0-9.62m.23 3.06a.2.2 0 0 0-.14-.1.2.2 0 0 0-.15.1l-.45.96-1.02.16a.2.2 0 0 0-.13.11q-.02.1.04.17l.74.75-.17 1.06q-.02.1.06.16t.17.02l.9-.5.92.5q.08.04.16-.02t.07-.16l-.18-1.06.74-.75a.2.2 0 0 0 .04-.17.2.2 0 0 0-.13-.11l-1.02-.16zm15.51 4.33q-.94 0-1.72-.33-.75-.33-1.2-.94-.43-.6-.45-1.44h1.95q.04.55.4.88t.98.33 1-.3q.37-.32.37-.8a1 1 0 0 0-.25-.67q-.25-.27-.62-.4-.38-.16-1.02-.34-.89-.27-1.44-.51a3 3 0 0 1-.95-.77q-.4-.51-.4-1.37 0-.81.41-1.4.4-.6 1.13-.92a4 4 0 0 1 1.67-.32q1.4 0 2.27.68.9.69.98 1.9h-2a1 1 0 0 0-.4-.76q-.38-.32-.98-.32-.54 0-.86.28-.3.27-.31.79 0 .37.23.61.26.24.6.4.36.13 1.01.33.89.26 1.45.52.55.25.96.78.4.52.4 1.36a2.6 2.6 0 0 1-1.48 2.36q-.73.36-1.73.36m5.45-8.16q-.48 0-.8-.3t-.32-.77q0-.45.32-.75t.8-.31.8.31q.32.3.32.75t-.33.77q-.3.3-.79.3m.9.86V19H36.6v-7.2zm3.36-2.42V19h-1.82V9.38zm4.54 7.94 1.82-5.52h1.94L47.4 19h-2.2l-2.65-7.2h1.95zm11.21-2.08q0 .4-.05.7h-5.26q.06.79.54 1.23.48.45 1.18.44 1.02 0 1.45-.87h1.96a3.3 3.3 0 0 1-3.37 2.38q-1.03 0-1.87-.46a3.4 3.4 0 0 1-1.29-1.31 4 4 0 0 1-.45-1.95q0-1.12.45-1.96.45-.85 1.28-1.3.81-.46 1.88-.46 1.03 0 1.84.44.81.45 1.26 1.26t.45 1.86m-1.88-.52q-.02-.7-.5-1.12a1.8 1.8 0 0 0-1.22-.42q-.68 0-1.14.41t-.56 1.13zm4.77-1.8q.35-.58.91-.9.58-.33 1.3-.33v1.92h-.48q-.85 0-1.3.4-.43.4-.43 1.4V19H58.6v-7.2h1.82z"
    />
    <defs>
      <radialGradient
        id="SilverBadge-silver-badge-bg"
        cx="0"
        cy="0"
        r="1"
        gradientTransform="matrix(35.5 0 0 96.9529 35.5 13.263)"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#fff" />
        <stop offset="1" stopColor="#bdbbb5" />
      </radialGradient>
    </defs>
  </svg>
);
SilverBadge.displayName = "SilverBadge";
